import { render } from "./OneDiagramComponent.vue?vue&type=template&id=1d2c1a24&scoped=true"
const script = {}

import "./OneDiagramComponent.vue?vue&type=style&index=0&id=1d2c1a24&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-10\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2c1a24"]])

export default __exports__